import Chip from '../../../shared/components/Chip/Chip'; import { STATUS_LABELS } from '../equipment.constants';
export default function EquipmentStatusChip({ status }) { return <Chip label={STATUS_LABELS[status] || status} size="small" />; }
